export const useIsShortMobileDevice = () => {
  return false;
};
